(function handleLoginRedirect() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    let loginRedirect = params.loginRedirect;
    let redirectUrl = params.redirectUrl;
    let isLoggedIn = document.getElementById('isLoggedIn');

    if (loginRedirect && isLoggedIn) {
        if (redirectUrl) {
            window.location.href = redirectUrl;
        } else {
            window.location.href = parent.location.pathname
                .replace("?loginRedirect=true", "")
                .replace("&loginRedirect=true", "");
        }
    }
})();

function redirectAsGuest(redirectUrl) {
    parent.location.href = redirectUrl;
}

window.addEventListener('message', function (event) {
    // Optionally check event.origin for security
    if (event.data.type === 'iframeLocationChange') {
        const iframe = document.querySelector('.js-loginIframe');
        if (event.data.page == 'signIn') {
            iframe.style.height = '33rem';
        }
        else if (event.data.page == 'signUp') {
            iframe.style.height = '48rem';
        }
        else {
            iframe.style.height = '33rem';
        }
    }
});


function successfulLogin() {
    var redirectUrl = document.getElementById("redirectUrl")?.value;
    if (!redirectUrl == null) {
        document.getElementById("redirectUrl").value;
    }

    if (redirectUrl) {

        var currentUrl = location.pathname;
        if (currentUrl.indexOf('?') > -1) {
            // If the current URL already has a query string, we just add a new query parameter
            location.href = location.pathname + '&loginRedirect=true&redirectUrl=' + redirectUrl;
        } else {
            // Otherwise, we add it as an initial query string
            location.href = location.pathname + '?loginRedirect=true&redirectUrl=' + redirectUrl;
        }
    }
    else {
        var currentUrl = location.pathname;
        if (currentUrl.indexOf('?') > -1) {
            // If the current URL already has a query string, we just add a new query parameter
            location.href = location.pathname + '&loginRedirect=true';
        } else {
            // Otherwise, we add it as an initial query string
            location.href = location.pathname + '?loginRedirect=true';
        }
    }
    //}, 500);
}

let loginModalLoaded = false;

function showLoginModal(redirectUrl, pageId) {
    if (!loginModalLoaded) {
        fetch(`/umbraco/surface/LoginModal/GetLoginCard?pageId=${pageId}`)
            .then(r => r.text())
            .then(html => {
                document.getElementById("loginModalContent").innerHTML = html;
                loginModalLoaded = true;

                initialiseLoginModal(redirectUrl);
            });

    } else {
        initialiseLoginModal(redirectUrl);
    }
}

function initialiseLoginModal(redirectUrl) {
    var iframe = document.querySelector(".js-loginIframe");

    if (iframe && !iframe.src) {
        iframe.src = iframe.dataset.src;
    }

    document.getElementById("redirectUrl").value = redirectUrl;

    var modal = document.getElementById("loginModal");
    modal.classList.add("modal--active");
    modal.style.display = "flex";
}

function hideLoginModal() {
    document.getElementById("loginModal").classList.remove("modal--active");
    document.getElementById("loginModal").style.display = "none";
}

function ToggleLoginSpinner(id) {
    const spinner = document.getElementById("loginSpinner_" + id);
    const iframe = document.getElementById("loginIframe_" + id);

    if (!spinner || !iframe) {
        return;
    }

    // Only hide spinner if the modal is visible (prevents first onload from hiding it too early)
    const modal = document.getElementById("loginModal");
    const isModalVisible = modal && modal.classList.contains("modal--active");

    if (isModalVisible) {
        spinner.style.display = "none";
    } else {
        spinner.style.display = "flex";
    }
}